import ReactCountryFlag from "react-country-flag";
import PropTypes from "prop-types";

const CountryFlag = ({ countryCode = "NG" }) => (
  <div className="flex items-center">
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{
        width: "1.2em",
        height: "1.2em",
        borderRadius: "30%",
      }}
      title={countryCode}
    />
  </div>
);

CountryFlag.propTypes = {
  countryCode: PropTypes.string,
};

export default CountryFlag;
